import { render, staticRenderFns } from "./Klassenliste.vue?vue&type=template&id=70cd67a1&"
import script from "./Klassenliste.vue?vue&type=script&lang=js&"
export * from "./Klassenliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports